import { Component } from "@angular/core";
import { Router } from "@angular/router";

interface QuickLink {
  title: string;
  icon: string;
  theme: string;
  route: string[];
}

@Component({
  selector: "app-quick-links",
  templateUrl: "./quick-links.component.html",
  styleUrls: ["./quick-links.component.scss"]
})
export class QuickLinksComponent {
  quickLinks: QuickLink[] = [
    {
      title: "Explore our unique PMS strategies",
      icon: "assets/icons/pms-strategies.svg",
      theme: "blue",
      route: ["/pms"]
    },
    {
      title: "Read our Blogs",
      icon: "assets/icons/blogs.svg",
      theme: "purple",
      route: ["/blog"]
    },
    {
      title: "Invest in our Model Portfolios",
      icon: "assets/icons/model-portfolios.svg",
      theme: "yellow",
      route: ["/explore/portfolios", ""]
    },
    {
      title: "Track your watchlist",
      icon: "assets/icons/watchlist.svg",
      theme: "green",
      route: ["/user/my-dashboard", "watchlist"]
    },
    {
      title: "Get your stock portfolio analysed",
      icon: "assets/icons/stock-analysis.svg",
      theme: "pink",
      route: ["/user/my-dashboard", "transactions"]
    },
    {
      title: "Get your mutual fund portfolio analysed",
      icon: "assets/icons/mutual-fund-analysis.svg",
      theme: "sky",
      route: ["/user/my-dashboard", "transactions"]
    },
    {
      title: "Get stock ideas",
      icon: "assets/icons/stock-ideas.svg",
      theme: "orange",
      route: ["/explore/ideas", "stocks"]
    },
    {
      title: "Get mutual fund ideas",
      icon: "assets/icons/mutual-fund-ideas.svg",
      theme: "mint",
      route: ["/explore/ideas", "mutual-funds"]
    }
  ];

  constructor(private router: Router) {}

  onQuickLinkClick(item: QuickLink): void {
    this.router.navigate(item.route);
  }
}
